const DOCTOR_SPECIALTIES = {
  doctor: ["01"],
  neurologist: ["32"],
  nephrologist: ["35"],
  cardiologist: ["03"],
  diabetologist: ["42"],
  gynecologist: ["07"],
  psychiatrist: ["33"],
  addictologist: [],
  psychologist: [],
  dentist: ["18", "19"],
  dermatologist: ["05"],
  ophtalmologist: ["15"],
  radiotherapist: ["74", "76"],
  radiologist: ["06"],
  surgeon: ["04", "16", "41", "47", "48", "49"],
  oncologist: ["71", "73", "74"],
  rheumatologist: ["14"],
  pulmonologist: [],
  "diabetologist-endocrinologist": [],
  mpr: [],
  physiotherapist: ["26"],
  orthopedist: [],
  "chiropodist-podiatrist": ["27"],
  "occupational-therapist": [],
  dietitian: [],
  gastroenterologist: [],
  hematologist: []
};

export default function doctorSpecialtyCodeToKey<
  K extends keyof typeof DOCTOR_SPECIALTIES
>(code: K): (typeof DOCTOR_SPECIALTIES)[K] {
  return DOCTOR_SPECIALTIES[code];
}
